<div [id]="mapId" class="map"></div>
<a [id]="imageId" download="constellation.png" crossorigin></a>